import $ from 'jquery'

$( document ).ready(function() {

    const getCookieValue = (name) => {
        const substrings = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        if( !substrings ) return ""
        return substrings.pop();
    }

    const removeSlash = (string) => {
        return string.replace(/\/$/, '')
    }


    const languageLinks = document.querySelectorAll('#modal-select-language .wpml-ls-item');
    languageLinks.forEach((link) => {
        const anchor = link.querySelector("a");
        anchor.setAttribute('href', anchor.getAttribute('href') + "?language-changed");
    })


    if (getCookieValue('acr_redirected') == 1) {
        const destination = !!getCookieValue('acr_redirect_language') ? getCookieValue('acr_redirect_language') : getCookieValue('_icl_visitor_lang_js').substring(0,2);

        if(removeSlash(location.protocol + '//' + location.host + location.pathname) !== removeSlash(document.querySelector("link[rel='alternate'][hreflang='" + destination +"']").getAttribute('href'))) {
            window.location.replace(document.querySelector("link[rel='alternate'][hreflang='" + destination +"']").getAttribute('href'))
        }
    }
    // console.log('cookie', getCookieValue("wordpress_test_cookie"))
    // console.log( document.querySelector("link[rel='alternate'][hreflang='it']").getAttribute('href'));
});